import { auth } from '@/auth'
import { NextResponse } from 'next/server'

const PUBLIC_PREFIXES = ['/login', '/about', '/company', '/contact', '/api/auth', '/api/users/register', '/api/dev-login']

export default auth((req) => {
  const { pathname } = req.nextUrl
  const isPublic = pathname === '/' || PUBLIC_PREFIXES.some((p) => pathname.startsWith(p))

  if (!isPublic && !req.auth) {
    const loginUrl = req.nextUrl.clone()
    loginUrl.pathname = '/login'
    loginUrl.searchParams.set('callbackUrl', pathname)
    return NextResponse.redirect(loginUrl)
  }
})

export const config = {
  matcher: [
    '/((?!_next/static|_next/image|favicon.ico|brand|icons|api/inngest).*)',
  ],
}
